(function () {
  const yearEl = document.getElementById("mkFooterYear");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  const footer = document.querySelector(".mk-footer-wrap");
  if (!footer) return;

  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  function loadAnime() {
    if (window.anime) return Promise.resolve(window.anime);

    return new Promise((resolve) => {
      const existing = document.querySelector('script[data-contactegy-anime="1"]');
      if (existing) {
        existing.addEventListener("load", () => resolve(window.anime || null), { once: true });
        existing.addEventListener("error", () => resolve(null), { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/animejs@3.2.1/lib/anime.min.js";
      script.async = true;
      script.dataset.contactegyAnime = "1";
      script.onload = () => resolve(window.anime || null);
      script.onerror = () => resolve(null);
      document.head.appendChild(script);
    });
  }

  loadAnime().then((anime) => {
    if (!anime) return;

    anime({
      targets: ".mk-footer-brand, .mk-footer-links",
      opacity: [0, 1],
      translateY: [20, 0],
      delay: anime.stagger(120),
      duration: 700,
      easing: "easeOutCubic",
    });

    anime({
      targets: ".mk-footer-phone, .mk-footer-link",
      opacity: [0, 1],
      translateY: [12, 0],
      delay: anime.stagger(45, { start: 160 }),
      duration: 450,
      easing: "easeOutQuad",
    });

    footer.querySelectorAll(".mk-footer-phone, .mk-footer-link").forEach((el) => {
      el.addEventListener("mouseenter", () => {
        anime.remove(el);
        anime({
          targets: el,
          scale: 1.05,
          duration: 170,
          easing: "easeOutQuad",
        });
      });
      el.addEventListener("mouseleave", () => {
        anime.remove(el);
        anime({
          targets: el,
          scale: 1,
          duration: 170,
          easing: "easeOutQuad",
        });
      });
    });
  });
})();